<template lang="pug">
footer.footer
  .footer-container
    .left
    .right
      .call-us
        p.call Call Us Today! #[span.phone {{ $store.state.phone }}]
        p.est 8:30AM to 8:00PM EST.
        p.pst 5:30AM to 5:00PM PST.
        p Copyright 2017 | NavLegal Notaries Inc.
</template>

<script>
export default {}
</script>

<style lang="scss">
.footer {
  background: #1c1c1c;
  height: 140px;
  .phone {
    font-weight: bold;
  }
}
.call {
  margin-bottom: 0;
}
.est,
.pst {
  margin: 0;
}
.footer-container {
  color: #fff;
  max-width: 1170px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: space-between;
}
.call-us {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?205aa5a6